/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { BusinessUnitResponse } from './';
import {
    BusinessUnitResponseFromJSON,
    BusinessUnitResponseFromJSONTyped,
    BusinessUnitResponseToJSON,
} from './';
import type { CommunityManagerResponse } from './';
import {
    CommunityManagerResponseFromJSON,
    CommunityManagerResponseFromJSONTyped,
    CommunityManagerResponseToJSON,
} from './';
import type { CountryManagerResponse } from './';
import {
    CountryManagerResponseFromJSON,
    CountryManagerResponseFromJSONTyped,
    CountryManagerResponseToJSON,
} from './';
import type { CountryResponse } from './';
import {
    CountryResponseFromJSON,
    CountryResponseFromJSONTyped,
    CountryResponseToJSON,
} from './';
import type { OpportunityTypeResponse } from './';
import {
    OpportunityTypeResponseFromJSON,
    OpportunityTypeResponseFromJSONTyped,
    OpportunityTypeResponseToJSON,
} from './';
import type { ProjectResponse } from './';
import {
    ProjectResponseFromJSON,
    ProjectResponseFromJSONTyped,
    ProjectResponseToJSON,
} from './';
import type { ProvidedClientResponse } from './';
import {
    ProvidedClientResponseFromJSON,
    ProvidedClientResponseFromJSONTyped,
    ProvidedClientResponseToJSON,
} from './';
import type { ReferredFreelancerResponse } from './';
import {
    ReferredFreelancerResponseFromJSON,
    ReferredFreelancerResponseFromJSONTyped,
    ReferredFreelancerResponseToJSON,
} from './';
import type { ReferrerResponse } from './';
import {
    ReferrerResponseFromJSON,
    ReferrerResponseFromJSONTyped,
    ReferrerResponseToJSON,
} from './';
import type { RejectReasonResponse } from './';
import {
    RejectReasonResponseFromJSON,
    RejectReasonResponseFromJSONTyped,
    RejectReasonResponseToJSON,
} from './';
import type { SalesManagerResponse } from './';
import {
    SalesManagerResponseFromJSON,
    SalesManagerResponseFromJSONTyped,
    SalesManagerResponseToJSON,
} from './';
import type { StatusResponse } from './';
import {
    StatusResponseFromJSON,
    StatusResponseFromJSONTyped,
    StatusResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface ReferralSubmissionResponse
 */
export interface ReferralSubmissionResponse {
    /**
     * 
     * @type {string}
     * @memberof ReferralSubmissionResponse
     */
    id: string;
    /**
     * 
     * @type {ProjectResponse}
     * @memberof ReferralSubmissionResponse
     */
    project: ProjectResponse;
    /**
     * 
     * @type {StatusResponse}
     * @memberof ReferralSubmissionResponse
     */
    status: StatusResponse;
    /**
     * 
     * @type {OpportunityTypeResponse}
     * @memberof ReferralSubmissionResponse
     */
    opportunityType: OpportunityTypeResponse;
    /**
     * Date of the referral submission
     * @type {Date}
     * @memberof ReferralSubmissionResponse
     */
    submissionDate?: Date;
    /**
     * 
     * @type {CountryResponse}
     * @memberof ReferralSubmissionResponse
     */
    country: CountryResponse;
    /**
     * 
     * @type {ReferrerResponse}
     * @memberof ReferralSubmissionResponse
     */
    referrer: ReferrerResponse;
    /**
     * 
     * @type {ProvidedClientResponse}
     * @memberof ReferralSubmissionResponse
     */
    providedClient: ProvidedClientResponse;
    /**
     * 
     * @type {ReferredFreelancerResponse}
     * @memberof ReferralSubmissionResponse
     */
    referredFreelancer?: ReferredFreelancerResponse;
    /**
     * 
     * @type {BusinessUnitResponse}
     * @memberof ReferralSubmissionResponse
     */
    businessUnit?: BusinessUnitResponse;
    /**
     * 
     * @type {SalesManagerResponse}
     * @memberof ReferralSubmissionResponse
     */
    salesManager?: SalesManagerResponse;
    /**
     * 
     * @type {CommunityManagerResponse}
     * @memberof ReferralSubmissionResponse
     */
    communityManager?: CommunityManagerResponse;
    /**
     * 
     * @type {CountryManagerResponse}
     * @memberof ReferralSubmissionResponse
     */
    countryManager?: CountryManagerResponse;
    /**
     * 
     * @type {number}
     * @memberof ReferralSubmissionResponse
     */
    referrerRate: number;
    /**
     * 
     * @type {string}
     * @memberof ReferralSubmissionResponse
     */
    opportunityLink?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralSubmissionResponse
     */
    advancedSearchDraftLink?: string;
    /**
     * 
     * @type {RejectReasonResponse}
     * @memberof ReferralSubmissionResponse
     */
    rejectReason?: RejectReasonResponse;
    /**
     * 
     * @type {string}
     * @memberof ReferralSubmissionResponse
     */
    slackLink?: string;
}

/**
 * Check if a given object implements the ReferralSubmissionResponse interface.
 */
export function instanceOfReferralSubmissionResponse(value: object): value is ReferralSubmissionResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('project' in value) || value['project'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('opportunityType' in value) || value['opportunityType'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('referrer' in value) || value['referrer'] === undefined) return false;
    if (!('providedClient' in value) || value['providedClient'] === undefined) return false;
    if (!('referrerRate' in value) || value['referrerRate'] === undefined) return false;
    return true;
}

export function ReferralSubmissionResponseFromJSON(json: any): ReferralSubmissionResponse {
    return ReferralSubmissionResponseFromJSONTyped(json, false);
}

export function ReferralSubmissionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralSubmissionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'project': ProjectResponseFromJSON(json['project']),
        'status': StatusResponseFromJSON(json['status']),
        'opportunityType': OpportunityTypeResponseFromJSON(json['opportunityType']),
        'submissionDate': json['submissionDate'] == null ? undefined : (new Date(json['submissionDate'])),
        'country': CountryResponseFromJSON(json['country']),
        'referrer': ReferrerResponseFromJSON(json['referrer']),
        'providedClient': ProvidedClientResponseFromJSON(json['providedClient']),
        'referredFreelancer': json['referredFreelancer'] == null ? undefined : ReferredFreelancerResponseFromJSON(json['referredFreelancer']),
        'businessUnit': json['businessUnit'] == null ? undefined : BusinessUnitResponseFromJSON(json['businessUnit']),
        'salesManager': json['salesManager'] == null ? undefined : SalesManagerResponseFromJSON(json['salesManager']),
        'communityManager': json['communityManager'] == null ? undefined : CommunityManagerResponseFromJSON(json['communityManager']),
        'countryManager': json['countryManager'] == null ? undefined : CountryManagerResponseFromJSON(json['countryManager']),
        'referrerRate': json['referrerRate'],
        'opportunityLink': json['opportunityLink'] == null ? undefined : json['opportunityLink'],
        'advancedSearchDraftLink': json['advancedSearchDraftLink'] == null ? undefined : json['advancedSearchDraftLink'],
        'rejectReason': json['rejectReason'] == null ? undefined : RejectReasonResponseFromJSON(json['rejectReason']),
        'slackLink': json['slackLink'] == null ? undefined : json['slackLink'],
    };
}

export function ReferralSubmissionResponseToJSON(value?: ReferralSubmissionResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'project': ProjectResponseToJSON(value['project']),
        'status': StatusResponseToJSON(value['status']),
        'opportunityType': OpportunityTypeResponseToJSON(value['opportunityType']),
        'submissionDate': value['submissionDate'] == null ? undefined : ((value['submissionDate']).toISOString().substring(0,10)),
        'country': CountryResponseToJSON(value['country']),
        'referrer': ReferrerResponseToJSON(value['referrer']),
        'providedClient': ProvidedClientResponseToJSON(value['providedClient']),
        'referredFreelancer': ReferredFreelancerResponseToJSON(value['referredFreelancer']),
        'businessUnit': BusinessUnitResponseToJSON(value['businessUnit']),
        'salesManager': SalesManagerResponseToJSON(value['salesManager']),
        'communityManager': CommunityManagerResponseToJSON(value['communityManager']),
        'countryManager': CountryManagerResponseToJSON(value['countryManager']),
        'referrerRate': value['referrerRate'],
        'opportunityLink': value['opportunityLink'],
        'advancedSearchDraftLink': value['advancedSearchDraftLink'],
        'rejectReason': RejectReasonResponseToJSON(value['rejectReason']),
        'slackLink': value['slackLink'],
    };
}

